// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
  'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
  sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.flex-row {
  display: flex;
  flex-direction: row;
  padding-top: 20px;
}

.App {
  text-align: center;
}
body {
  font-family: 'Segoe UI', sans-serif;
  background: #fff7f0;
  padding: 2rem;
}

.table-container {
  overflow-x: auto;
  background: white;
  border-radius: 12px;
  border: 1px solid #f1a675;
}

table {
  width: 100%;
  border-collapse: collapse;
  min-width: 600px;
}

thead {
  background-color: #f38e3c;
  color: #252525;
}

th, td {
  padding: 1rem;
  text-align: left;
  transition: background-color 0.2s ease;
}

tbody tr {
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
}

tbody tr:hover {
  background-color: #ffe6d6;
}

tbody tr:active, .selected-tr {
  background-color: #ffbe96 !important;
}

tr + tr td {
  border-top: 1px solid #ffe0b2;
}

@media (max-width: 768px) {
  th, td {
    padding: 0.75rem;
    font-size: 0.9rem;
  }
}


.btn1 {
  /* Variables */
  --button_radius: 0.75em;
  --button_color: #e8e8e8;
  --button_outline_color: #000000;
  font-size: 17px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  border-radius: var(--button_radius);
  background: var(--button_outline_color);
  padding-left: 0;
  padding-right: 0;
}

.btn1 span  {
  display: block;
  box-sizing: border-box;
  border: 2px solid var(--button_outline_color);
  border-radius: var(--button_radius);
  padding: 0.75em 1.5em;
  background: var(--button_color);
  color: var(--button_outline_color);
  transform: translateY(-0.2em);
  transition: transform 0.1s ease;
}

.btn1:hover span {
  /* Pull the button upwards when hovered */
  transform: translateY(-0.33em);
}

.btn1:active span {
  /* Push the button downwards when pressed */
  transform: translateY(0);
}

.select-dropdown,
.select-dropdown * {
  margin: 0;
  padding: 0;
  position: relative;
  box-sizing: border-box;
}
.select-dropdown {
  position: relative;
  background-color: #E6E6E6;
  border-radius: 4px;
}
.select-dropdown select {
  font-size: 1rem;
  font-weight: normal;
  max-width: 100%;
  padding: 8px 24px 8px 10px;
  border: none;
  background-color: transparent;
  appearance: none;
}
.select-dropdown select:active, .select-dropdown select:focus {
  outline: none;
  box-shadow: none;
}
.select-dropdown:after {
  content: "";
  position: absolute;
  top: 50%;
  right: 8px;
  width: 0;
  height: 0;
  margin-top: -2px;
  border-top: 5px solid #aaa;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;YAEU;EACV,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;;AAGA;EACE,cAAc;EACd,uBAAuB;EACvB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,6CAA6C;EAC7C,mCAAmC;EACnC,qBAAqB;EACrB,+BAA+B;EAC/B,kCAAkC;EAClC,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,wBAAwB;AAC1B;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,YAAY;EACZ,6BAA6B;EAE7B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;AACpC","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n  'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n  sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row;\n  padding-top: 20px;\n}\n\n.App {\n  text-align: center;\n}\nbody {\n  font-family: 'Segoe UI', sans-serif;\n  background: #fff7f0;\n  padding: 2rem;\n}\n\n.table-container {\n  overflow-x: auto;\n  background: white;\n  border-radius: 12px;\n  border: 1px solid #f1a675;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 600px;\n}\n\nthead {\n  background-color: #f38e3c;\n  color: #252525;\n}\n\nth, td {\n  padding: 1rem;\n  text-align: left;\n  transition: background-color 0.2s ease;\n}\n\ntbody tr {\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.1s ease;\n}\n\ntbody tr:hover {\n  background-color: #ffe6d6;\n}\n\ntbody tr:active, .selected-tr {\n  background-color: #ffbe96 !important;\n}\n\ntr + tr td {\n  border-top: 1px solid #ffe0b2;\n}\n\n@media (max-width: 768px) {\n  th, td {\n    padding: 0.75rem;\n    font-size: 0.9rem;\n  }\n}\n\n\n.btn1 {\n  /* Variables */\n  --button_radius: 0.75em;\n  --button_color: #e8e8e8;\n  --button_outline_color: #000000;\n  font-size: 17px;\n  font-weight: bold;\n  border: none;\n  cursor: pointer;\n  border-radius: var(--button_radius);\n  background: var(--button_outline_color);\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.btn1 span  {\n  display: block;\n  box-sizing: border-box;\n  border: 2px solid var(--button_outline_color);\n  border-radius: var(--button_radius);\n  padding: 0.75em 1.5em;\n  background: var(--button_color);\n  color: var(--button_outline_color);\n  transform: translateY(-0.2em);\n  transition: transform 0.1s ease;\n}\n\n.btn1:hover span {\n  /* Pull the button upwards when hovered */\n  transform: translateY(-0.33em);\n}\n\n.btn1:active span {\n  /* Push the button downwards when pressed */\n  transform: translateY(0);\n}\n\n.select-dropdown,\n.select-dropdown * {\n  margin: 0;\n  padding: 0;\n  position: relative;\n  box-sizing: border-box;\n}\n.select-dropdown {\n  position: relative;\n  background-color: #E6E6E6;\n  border-radius: 4px;\n}\n.select-dropdown select {\n  font-size: 1rem;\n  font-weight: normal;\n  max-width: 100%;\n  padding: 8px 24px 8px 10px;\n  border: none;\n  background-color: transparent;\n  -webkit-appearance: none;\n  appearance: none;\n}\n.select-dropdown select:active, .select-dropdown select:focus {\n  outline: none;\n  box-shadow: none;\n}\n.select-dropdown:after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  right: 8px;\n  width: 0;\n  height: 0;\n  margin-top: -2px;\n  border-top: 5px solid #aaa;\n  border-right: 5px solid transparent;\n  border-left: 5px solid transparent;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
